// extracted by mini-css-extract-plugin
export default {"tabIcon":"InstallPWA_tabIcon__QH9LN","tabMobile":"InstallPWA_tabMobile__kMc3C","tabLabel":"InstallPWA_tabLabel__Y1uVh"};